import { render, staticRenderFns } from "./YouTubeChannels.vue?vue&type=template&id=f507323a&scoped=true"
import script from "./YouTubeChannels.vue?vue&type=script&lang=js"
export * from "./YouTubeChannels.vue?vue&type=script&lang=js"
import style0 from "./YouTubeChannels.vue?vue&type=style&index=0&id=f507323a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f507323a",
  null
  
)

export default component.exports